module.exports = __webpack_public_path__ + "static/media/thumbnail.65cf1a31.png";